import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const useOnboardingScreenQueries = () => {
  const projectId = useProjectId();
  const api = useApi();

  return {
    list: () =>
      queryOptions({
        queryKey: QUERY_KEYS.ONBOARDING_SCREENS_LIST(projectId),
        queryFn: () => api.getOnboardingScreensV1(),
        select: (res) => {
          const data = commonAPIDataSelector(res);

          return data.items;
        },
      }),
    details: ({ onboardingScreenId }: { onboardingScreenId: string }) =>
      queryOptions({
        queryKey: QUERY_KEYS.ONBOARDING_SCREENS_DETAILS(projectId, onboardingScreenId),
        queryFn: () => api.getOnboardingScreensDetailsV1(onboardingScreenId),
        select: commonAPIDataSelector,
      }),
  };
};
